module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1a459fb9ec644b013da6b849d2cffce2.gif";